export default __webpack_public_path__ + "static/media/reload.def179f1.svg";